export default {
    ufModalNameInput: '/dial-plans/modal/input/name',
    rules: {
        ufNameInput: '/dial-plans/rules/input/name',
        ufPriorityInput: '/dial-plans/rules/input/priority',
        ufPatternInput: '/dial-plans/rules/input/pattern',
        ufTranslationInput: '/dial-plans/rules/input/translation',
    },
};
